export default {
  showMobileMenu: state => state.showMobileMenu,
  isMobileView: state => state.isMobileView,
}